<template>
  <main>
    <HeaderMarketing
      buttonTitle="Editar"
      buttonTitle2="Excluir"
      title="Marketing"
      text="Cadastre sua campanha de marketing, adicione banners e gerencie suas ações"
      @voltar="goToRoute('/marketing')"
      :haveAction="false"
      :haveBack="true"
    />

    <v-container style="max-width: unset" class="pa-4">
      <v-tabs class="pa-0 ma-0" background-color="#ECEEF1" grow height="35" hide-slider>
        <v-tab
          active-class="active-tab"
          class="tab"
          id="tab0"
          style="font-weight: bold !important"
          href="#mobile-tabs-5-0"
          @click="(activeTab = 0), updateTable()"
        >
          <span>Banners</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item
          :value="0"
          class="pa-0 ma-0"
          style="background-color: #eeeeee !important"
        >
          <v-card class="ma-0 pa-2">
            <v-form ref="form" v-model="firstValid" :key="clear">
              <v-row class="pa-0 py-0 ma-0">
                <v-col class="pa-0 px-0" cols="12" sm="4" md="4" lg="4">
                  <p class="ma-0 py-2 label-details">Banner Ativo?*</p>

                  <v-switch
                    v-model="currentBanner.bannerStatus"
                    inset
                    color="normalred"
                    :label="switch1 ? 'Ativo' : 'Inativo'"
                  ></v-switch>
                </v-col>

                <v-col  cols="12" sm="8" md="8" lg="8" class="px-0 pa-1">
                  <div class="d-flex align-start justify-end flex-wrap ma-0 pa-0" style="width: 100%!important;">

                    <div :key="componentimageMobileKey" class="d-flex flex-column align-center justify-center" >
                      <p class="ma-0 py-1 text-center">Mobile</p>
                      <v-hover v-slot="{ hover }" v-if="currentBanner.imageMobile != null">
                        <v-img
                            :src="currentBanner.imageMobile"
                            style="
                            border-radius: 5px !important;
                            opacity: 0.7;
                            cursor: pointer;"
                            height="180"
                            width="300"
                            :class="hover ? 'elevation-5 mx-2' : 'mx-2'"
                        >
                          <v-expand-transition>
                            <div
                                v-if="hover"
                                class="d-flex flex-column justify-center align-center"
                                style="height: 100%; background: rgba(188, 0, 0, 0.6)"
                                @click="openPicker('imageInputMobile')"
                            >
                              <v-icon size="26" color="white">mdi-pen</v-icon>
                              <span class="edit-photo">Alterar foto</span>
                            </div>
                          </v-expand-transition>
                        </v-img>
                      </v-hover>

                      <span
                          class="delete-photo"
                          v-if="currentBanner.imageMobile != null"
                          @click="(currentBanner.imageMobile = null)"
                      >
                        Excluir
                      </span>

                      <div class="d-flex flex-column align-center" v-if="currentBanner.imageMobile == null">
                        <v-hover>
                          <div class="image-container mx-2" @click="openPicker('imageInputMobile')">
                            <div class="d-flex flex-column align-center">
                              <v-img
                                  src="../../../assets/add_photo.svg"
                                  contain
                                  max-width="46"
                              >
                              </v-img>
                              <span class="photo-field">Adicionar Foto</span>
                            </div>
                          </div>
                        </v-hover>
                      </div>
                    </div>

                    <v-file-input
                        style="display: none"
                        :disabled="isDetailImageMobile"
                        id="imageInputMobile"
                        accept="image/png, image/jpeg, image/jpg"
                        :label="'Nenhuma imagem selecionada'"
                        filled
                        prepend-icon="mdi-camera"
                        @change="setImageMobile"
                        required
                    ></v-file-input>

                    <div :key="componentKey" class="d-flex flex-column align-center justify-center" >
                      <p class="ma-0 py-1 text-center">Desktop</p>
                      <v-hover v-slot="{ hover }" v-if="currentBanner.image != null">
                        <v-img
                            :src="currentBanner.image"
                            style="
                            border-radius: 5px !important;
                            opacity: 0.7;
                            cursor: pointer;"
                            height="180"
                            width="300"
                            :class="hover ? 'elevation-5 mx-2' : 'mx-2'"
                        >
                          <v-expand-transition>
                            <div
                                v-if="hover"
                                class="d-flex flex-column justify-center align-center"
                                style="height: 100%; background: rgba(188, 0, 0, 0.6)"
                                @click="openPicker('imageInput')"
                            >
                              <v-icon size="26" color="white">mdi-pen</v-icon>
                              <span class="edit-photo">Alterar foto</span>
                            </div>
                          </v-expand-transition>
                        </v-img>
                      </v-hover>

                      <span
                          class="delete-photo"
                          v-if="currentBanner.image != null"
                          @click="(currentBanner.image = null)"
                      >
                        Excluir
                      </span>

                      <div
                          class="d-flex flex-column align-center"
                          v-if="currentBanner.image == null"
                      >
                        <v-hover>
                          <div
                              class="image-container mx-2"
                              @click="openPicker('imageInput')"
                          >
                            <div class="d-flex flex-column align-center">
                              <v-img
                                  src="../../../assets/add_photo.svg"
                                  contain
                                  max-width="46"
                              >
                              </v-img>
                              <span class="photo-field">Adicionar Foto</span>
                            </div>
                          </div>
                        </v-hover>
                      </div>
                    </div>

                    <v-file-input
                        style="display: none"
                        :disabled="isDetail"
                        id="imageInput"
                        accept="image/png, image/jpeg, image/jpg"
                        :label="'Nenhuma imagem selecionada'"
                        filled
                        prepend-icon="mdi-camera"
                        @change="setImage"
                        required
                    ></v-file-input>
                  </div>
                </v-col>
              </v-row>

              <v-row justify="start">
                <v-col class="px-3 ma-0" cols="12" sm="6" md="5" lg="6">
                  <span class="ma-0 pa-0 label-details">Título do Banner *</span>
                  <v-text-field
                      :disabled="isDetail"
                      outlined
                      v-model="currentBanner.title"
                      class="pa-0 ma-0"
                      height="52"
                      style="border: 1px solid #979797; border-radius: 8px;"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength="125"
                      background-color="#F5F5F5"
                      hide-details
                      placeholder="Título da Banner"
                      required
                  ></v-text-field>
                  <br/>
                  <span class="ma-0 pa-0 label-details">Link de publicação ao clicar</span>
                  <v-text-field
                      :disabled="isDetail"
                      outlined
                      v-model="currentBanner.link"
                      class="pa-0"
                      style="border: 1px solid #979797; border-radius: 8px"
                      height="52"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength="125"
                      background-color="#F5F5F5"
                      hide-details
                      placeholder="Colar link"
                  ></v-text-field>
                </v-col>


                <v-col style="margin-top: 12px;"  class="px-3 ma-0" cols="12" sm="6" md="6" lg="6">
                  <span class="ma-0 py-3">Validade inicial(opcional):</span>
                  <v-text-field
                      v-model="dateFormatted"
                      type="date"
                      class="pa-0"
                      :disabled="invalidData"
                      style="border: 1px solid #979797; border-radius: 8px"
                      background-color="#F5F5F5"
                      :placeholder="invalidData ? ' Indeterminado' : ' DD/MM/AAAA'"
                      hide-details
                      outlined
                      height="52"
                  ></v-text-field>

                  <!--<v-menu
                      ref="menu"
                      :key="componentKey"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      required
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          :disabled="invalidData"
                          class="date-input pa-0 ma-0"
                          v-model="dateFormatted"
                          hide-details
                          height="55"
                          append-outer-icon="mdi-calendar-check-outline"
                          :placeholder="invalidData ? ' Indeterminado' : ' DD/MM/AAAA'"
                          readonly
                          v-bind="attrs"
                          @blur="date = parseDate(dateFormatted)"
                          v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                        locale="pt-br"
                        v-model="date"
                        no-title

                        :active-picker.sync="activePicker"
                        :max="
                        new Date(Date.now() + new Date().getTimezoneOffset() * 300000000)
                          .toISOString()
                          .substr(0, 10)
                      "
                        min="2019-04-11"
                        @change="save"
                    ></v-date-picker>
                  </v-menu>-->
                  <br/>
                  <!-- FIM -->
                  <span class="ma-0 py-3">Validade Final(opcional):</span>

                  <v-text-field
                      v-model="dateFormatted2"
                      type="date"
                      class="pa-0"
                      :disabled="invalidData"
                      style="border: 1px solid #979797; border-radius: 8px"
                      background-color="#F5F5F5"
                      :placeholder="invalidData ? ' Indeterminado' : ' DD/MM/AAAA'"
                      hide-details
                      outlined
                      height="52"
                  ></v-text-field>
                  <!--<v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          :disabled="invalidData"
                          class="date-input pa-0 ma-0"
                          v-model="dateFormatted2"
                          hide-details
                          height="55"
                          append-outer-icon="mdi-calendar-check-outline"
                          :placeholder="invalidData ? ' Indeterminado' : ' DD/MM/AAAA'"
                          readonly
                          v-bind="attrs"
                          @blur="date2 = parseDate(dateFormatted2)"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date2"
                        locale="pt-br"
                        no-title
                        :active-picker.sync="activePicker2"
                        :max="
                        new Date(Date.now() + new Date().getTimezoneOffset() * 300000000)
                          .toISOString()
                          .substr(0, 10)
                      "
                        min="2019-04-11"
                        @change="save2"
                    ></v-date-picker>
                  </v-menu>-->
                </v-col>
              </v-row>
              <!--<v-divider></v-divider>-->

              <!--<v-row class="pa-6 py-3 ma-0">-->
                <!-- TITULO -->
                <!--<v-col
                  class="pa-5"
                  style="align-self: center"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <div>
                    <div class="date-title">Data do Banner</div>
                    <div>Escolha a melhor data para o banner ficar ativo</div>
                  </div>
                </v-col>-->
                <!-- DATAS -->
              <!--</v-row>-->

              <v-row class="pa-6 py-6 ma-0" style="justify-content: center">
                <v-col cols="12" md="3" sm="6" lg="6">
                  <v-btn
                    :disabled="isDetail"
                    class="cancel-button"
                    outlined
                    block
                    height="45"
                    style="border-radius: 10px"
                    @click="goToRoute('/marketing')"
                  >
                    Cancelar
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3" sm="6" lg="6">
                  <v-btn
                    :disabled="isDetail"
                    class="secondary-button"
                    block
                    style="font-weight: bold !important"
                    :loading="loading"
                    @click="submit()"
                    >{{ isEditing ? "Alterar Banner" : "Cadastrar Banner" }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </main>
</template>

<style scoped>
::placeholder {
  color: blue!important;
  font-size: 1.5em!important;
}
.delete-photo {
  cursor: pointer;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
}

.edit-photo {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
}

.photo-field {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  /* identical to box height */

  letter-spacing: 0.15px;

  color: #9c9c9c;
}
.image-container {

  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px!important;
  height: 180px;
  background: #dadada;
  cursor: pointer;
  transition: 0.1s;
  box-sizing: border-box;
  border-radius: 5px !important;
}
@media (max-width: 600px) {
  .image-container {
    width: 200%;
  }
}
@media (max-width: 900px) {
  .image-container {
    width: 200%;
  }
}
@media (max-width: 300px) {
  .image-container {
    width: 145%;
  }
}
.cancel-button {
  border-radius: 7.5px !important;
  transition: 0.3s !important;
}

.cancel-button:hover {
  color: white !important;
  background: #000000 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2) !important;
}

.date-input {
  background: #f5f5f5;
  text-align: center !important;
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 8px;
  border-right-style: inset !important;
}
.date-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.15px;

  color: #232021;
}
.title-g {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 40px;

  color: #000000;
}
.texto-p {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 35px;
  color: #9c9c9c;
}
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}
</style>
<script>
import HeaderMarketing from "./components/HeaderMarketing/HeaderMarketing.vue";
import ApiService from "../../../services/ApiService";
import Vue from "vue";
import moment from "moment";


export default {
  components: {
    HeaderMarketing,
  },
  data: () => ({
    currentBanner: {
      imageMobile: null,
      image: null,
    },
    type1: false,
    type2: false,
    dateFormatted: "",
    dateFormatted2: "",
    activePicker: null,
    activePicker2: null,
    date: null,
    date2: null,
    menu: false,
    menu2: false,
    invalidData: false,
    isEditing: false,
    isDetail: false,
    isDetailImageMobile: false,
    switch1: false,
    clear: false,
    componentKey: 1,
    componentimageMobileKey: 2,
    firstValid: true,
    activeTab: 0,
    configs: [
      { label: "Mais configurações", value: 0 },
      { label: "Criar Vitrine", value: 1 },
    ],
    closeNoLoading: false,
    apiService: new ApiService(),

    loading: false,
    page: 1,
    sizes: [15, 30, 90, 180],
    totalPages: 1,
    pageSize: 15,
    filter: {
      page: 1,
      pageSize: 15,
    },
    headers: [
      {
        text: "Banner",
        class: "item",
        value: "pic",
        align: "center",
        sortable: false,
      },
      {
        text: "Posição",
        class: "item",
        value: "'Full banner'",
        align: "center",
        sortable: false,
      },
      {
        text: "Data de início",
        class: "item",
        value: "validate_initial",
        align: "center",
      },

      { text: "Status", class: "item", value: "status", align: "center" },

      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],

    headerProps: { sortByText: "Ordenar por" },
  }),
  async mounted() {
    if (this.$route.query.isEditing != null) {
      this.isEditing = true;
    }

    if (this.$route.query.id) {
      await this.apiService
        .get(`marketing/get-one-banner?id=` + this.$route.query.id)
        .then((response) => {
          this.currentBanner = response;
          this.dateFormatted = response.validate_initial ? moment(response.validate_initial).format("YYYY-MM-DD") : null;
          this.dateFormatted2 = response.validate_end ? moment(response.validate_end).format("YYYY-MM-DD") : null;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    }
  },
  methods: {
    async submit() {
      this.loading = true;
      if (
        this.$refs.form.validate() &&
        this.currentBanner.image != null &&
        this.currentBanner.imageMobile != null &&
        this.currentBanner.title != null
      ) {
        const model = {
          Id: this.currentBanner.id,
          Title: this.currentBanner.title,
          Image: this.currentBanner.image,
          ImageMobile: this.currentBanner.imageMobile,
          Link: this.currentBanner.link,
          Secondary: this.$route.query.secondary ? this.$route.query.secondary : false,
          BannerStatus: this.currentBanner.bannerStatus,
          Validate_initial: this.dateFormatted,
          Validate_end: this.dateFormatted2 ? `${this.dateFormatted2} 23:59:59` : null,
        };
        let url = "marketing/add-banner";
        if (this.isEditing) {
          url = "marketing/edit-banner";
        }
        this.apiService
          .post(url, model)
          .then((response) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Banner cadastrado com sucesso",
              message: `${this.isEditing ? 'Banner alterado com sucesso' : 'Banner cadastrado com sucesso'}`,
              trace: null,
            });

            this.loading = false;
            this.goToRoute("/marketing");
          })
          .catch((err) => {
            if (this.isEditing) {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro ao alterar banner",
                message: "Erro ao alterar banner",
                trace: null,
              });
            } else {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro ao cadastrar banner",
                message: "Erro ao cadastrar banner",
                trace: null,
              });
            }

            this.loading = false;
          });
      } else {
        this.loading = false;
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Preencha todos os campos obrigatórios",
          message: "Preencha todos os campos obrigatórios",
          trace: null,
        });
      }
    },
    showPhoto(image) {
      if (!!image && image.includes("Uploads/")) {
        const env_url = process.env.VUE_APP_BASE_URL;
        return env_url + image;
      } else {
        return image;
      }
    },
    openPicker(idInput) {
      document.querySelector(`#${idInput}`).click();
    },

    setImage(image) {
      if (image.size < 2097152) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.currentBanner.image = reader.result;
        };
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "warning",
          title: "",
          message: "Arquivo excede o limite de 2mb",
          trace: null,
        });
      }
    },
    setImageMobile(image) {
      if (image.size < 2097152) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.currentBanner.imageMobile = reader.result;
        };
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "warning",
          title: "",
          message: "Arquivo excede o limite de 2mb",
          trace: null,
        });
      }
    },

    async goToRoute(route) {
      if (this.$route.path != route) {
        await this.$router.push(route);
      }
    },

    showSuccess(message) {
      this.$emit("show", message);
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    save(date) {
      this.$refs.menu.save(date);
    },
    save2(date) {
      this.$refs.menu2.save(date);
    },
  },

  watch: {
    date2(val) {
      this.dateFormatted2 = this.formatDate(this.date2);
    },
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },

    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },

    pageSize() {
      this.filter.pageSize = this.pageSize;
      this.updateTable();
    },

    page() {
      this.filter.page = this.page;
      this.updateTable();
    },
  },
};
</script>
